import React from 'react'
import { Badge } from 'antd'

// Use a fixed reference date to ensure consistent display (April 2, 2025, 09:30:00)
const CURRENT_REFERENCE_DATE = new Date('2025-04-02T09:30:00')

// Format time for display (e.g., "2h 30m")
export const formatTime = (minutes) => {
  if (minutes === null || minutes === undefined) return '-'
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`
}

// Get status badge for theatre
export const getStatusBadge = (status) => {
  switch (status) {
    case 'Active':
      return <Badge status='processing' text='Active' />
    case 'Idle':
      return <Badge status='success' text='Ready' />
    case 'Cleaning':
      return <Badge status='warning' text='Cleaning' />
    default:
      return <Badge status='default' text={status} />
  }
}

// Get schedule time display
export const getScheduleTime = (dateTimeString) => {
  if (!dateTimeString) return '-'
  const dateTime = new Date(dateTimeString)
  return dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

// Get color for progress bar
export const getProgressColor = (progress) => {
  if (progress < 50) return '#52c41a' // green
  if (progress < 80) return '#faad14' // yellow
  return '#f5222d' // red (running over time)
}

// Calculate elapsed and remaining time using fixed reference date
export const calculateTimeInfo = (startTime, estimatedEndTime) => {
  if (!startTime) {
    return { elapsed: 0, remaining: 0, progress: 0 }
  }

  const start = new Date(startTime)
  const now = CURRENT_REFERENCE_DATE
  const end = estimatedEndTime ? new Date(estimatedEndTime) : null

  // Calculate elapsed time in minutes
  const elapsedMs = now - start
  const elapsedMinutes = Math.floor(elapsedMs / (1000 * 60))

  // Calculate remaining time if end time is provided
  let remainingMinutes = 0
  if (end) {
    const remainingMs = end - now
    remainingMinutes = Math.max(0, Math.floor(remainingMs / (1000 * 60)))
  }

  // Calculate progress percentage
  let progress = 0
  if (end) {
    const totalDuration = end - start
    progress = Math.min(100, Math.round((elapsedMs / totalDuration) * 100))
  }

  return {
    elapsed: elapsedMinutes,
    remaining: remainingMinutes,
    progress: progress
  }
}
